module.exports = __webpack_public_path__ + "static/media/logo-right.33e265ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-right.png
// module id = 53
// module chunks = 0